import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class EquipmentDetails extends Component {
  handleClick_deleteEquipment = (e) => {
    e.preventDefault();
    this.props.toggleAlert_deleteEquipment();
  };

  handleClick_editEquipment = (e) => {
    e.preventDefault();
    this.props.editEquipment();
  };

  render() {
    const { equipmentDetails: equipment } = this.props;
    return (
      <React.Fragment>
        {equipment ? (
          <React.Fragment>
            <h3 className="card-title mx-0">{equipment.makeDesc}</h3>
            <h5 className="card-subtitle text-muted mx-0">{equipment.contractorName}</h5>
          </React.Fragment>
        ) : (
          <h5 className="text-muted">No equipment selected</h5>
        )}
        {equipment && (
          <React.Fragment>
            <div className="row ml-0 mt-2">
              <div className="col pl-0">
                <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Number:</b>
                      </div>
                      <div className="col pl-1">{equipment.number || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Class:</b>
                      </div>
                      <div className="col pl-1">{equipment.equipClass || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Make:</b>
                      </div>
                      <div className="col pl-1">{equipment.make || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Rate:</b>
                      </div>
                      <div className="col pl-1">{equipment.rate || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Delay Factor:</b>
                      </div>
                      <div className="col pl-1">{equipment.delayFactor || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>OT Factor:</b>
                      </div>
                      <div className="col pl-1">{equipment.otFactor || "(N/A)"}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-row form-group align-middle">
              <button
                type="button"
                name="editEquipmentDetails"
                id="editEquipmentDetails"
                className="btn btn-secondary mr-2"
                onClick={this.handleClick_editEquipment}
              >
                Edit...
              </button>
              <button
                type="button"
                name="deleteEquipment"
                id="deleteEquipment"
                className="btn btn-danger mr-2"
                onClick={this.handleClick_deleteEquipment}
                disabled={equipment.hasLinks}
              >
                Delete
              </button>
              {equipment.hasLinks && (
                <button
                  type="button"
                  name="equipInUse"
                  id="equipInUse"
                  className="btn btn-link text-muted p-1"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                  In Use
                </button>
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  equipmentDetails: state.equipment.openEquipmentDetails[ownProps.projectId]
    ? state.equipment.openEquipmentDetails[ownProps.projectId][ownProps.equipmentId] ||
      null
    : null,
});
export default connect(mapStateToProps)(EquipmentDetails);
